export default __webpack_public_path__ + "static/media/330_business03-fr-web.8fd2df83.png";